export function Btn({ children, onClick, variant = "primary", size = "md", style: sx = {}, disabled = false, type = "button" }) {
  const base = {
    cursor: "pointer",
    border: "none",
    borderRadius: 8,
    fontFamily: "inherit",
    fontWeight: 600,
    letterSpacing: "0.03em",
    transition: "all 0.18s",
    outline: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    justifyContent: "center",
    opacity: disabled ? 0.7 : 1,
    pointerEvents: disabled ? "none" : "auto",
  };

  const sizes = {
    sm: { fontSize: 12, padding: "6px 14px" },
    md: { fontSize: 14, padding: "10px 20px" },
    lg: { fontSize: 15, padding: "13px 28px" },
  };

  const variants = {
    primary: { background: "#3b82f6", color: "#fff" },
    secondary: { background: "transparent", color: "#3b82f6", border: "1.5px solid #3b82f6" },
    danger: { background: "#ef4444", color: "#fff" },
    ghost: { background: "rgba(255,255,255,0.07)", color: "#cbd5e1" },
  };

  return (
    <button
      type={type}
      disabled={disabled}
      style={{ ...base, ...sizes[size], ...variants[variant], ...sx }}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
